/* src/app/private/components/department/delete-department/delete-department.component.scss */
/*# sourceMappingURL=delete-department.component.css.map */
